<template>
  <div class="page content-page">

    <div class="columns">
      <div class="column">
          
          <h1>köhler. Ihr Partner für Fassade und Stein.</h1>
      </div>
    </div>
    <div class="columns flex wrap ">



      <div class="column">
          <h2>Erleben Sie die Faszination Stein.</h2>
          <p>Unsere Kernkompetenz ziehen wir aus der jahrzehntelangen Erfahrung mit dem Produkt Klinker. Wir haben ein umfassendes Netzwerk aus Spezialisten um uns versammelt, die wie wir die Faszination Stein in sich tragen. </p>
          <p>Was immer Sie mit Klinker und Riemchen vorhaben – wir sind der passende Partner, der für Sie in Stein denkt.</p>
          <p>
            <a class="button" href="tel:+492116016020">0211 - 601 602 0</a>
            <a class="button" href="mailto:info@koehler-klinker.de">E-Mail schreiben</a>
             <a class="button" href="https://www.koehler-klinker.de" target="_blank" rel="noopener">Zur Website von köhler.</a>
            </p>

      </div>
      <div class="column">
      </div>
    </div>
  </div>
</template>
<script>
export default {
    name: 'AboutPage',
    data: function(){
      return {
         }
    },
    methods: {},
    created: function(){
    },
    mounted: function(){},
    computed: {}
}  
</script>
<style>
</style>